import { AudiogramConfig } from '.'
import { DEFAULT_WORDS } from './defaultSubtitles'
import { THEMES } from './themes'

const gregarious = {
  avatarUrl:
    'https://pbs.twimg.com/profile_images/1746332567467364352/PJCQcUip_400x400.jpg',
  name: 'Gregarious',
  role: 'HOST',
  speakingTime: 300,
  username: '@gregarious',
} as const
const petrbela = {
  avatarUrl:
    'https://pbs.twimg.com/profile_images/991068099469164544/7w810jYV.jpg',
  name: 'Petr Bela',
  role: 'SPEAKER',
  speakingTime: 200,
  username: '@petrbela',
} as const

const defaultEpisode = {
  image: 'https://picsum.photos/seed/33/200/400',
  title: 'Audiograms, Audiograms, Audiograms',
  subtitle: 'Hosted by Zealous',
} as const

export const defaultWrapConfig: AudiogramConfig = {
  episode: defaultEpisode,
  reactions: [
    { emoji: '❤️', count: 230 },
    { emoji: '😅', count: 12 },
  ],
  scenes: [
    { kind: 'title', duration: 2 },
    { kind: 'speaking', duration: 2 },
    { kind: 'keywords', duration: 2 },
    { kind: 'reactions', duration: 2 },
    {
      kind: 'clip',
      duration: 3,
      mediaUrl:
        'https://storage.googleapis.com/zealous-rooms.appspot.com/recordings%2Fmtg_2Gs7UQ5tSs3aVdVVdcwGrBYD7as%2F1PlKQpnjvpVxE-utt_2Gs7WbgEIKf0Rw95lB3eNqqoyx2-clip.m4a',
      layout: 'avatar',
      paragraphs: [{ start: 0, end: 3, speaker: gregarious }],
      words: DEFAULT_WORDS,
      theme: THEMES[2]!.config,
      title: defaultEpisode.title,
      subtitle: defaultEpisode.subtitle,
      imageUrl: defaultEpisode.image,
    },
    {
      kind: 'clip',
      duration: 3,
      mediaUrl:
        'https://storage.googleapis.com/zealous-rooms.appspot.com/recordings%2Fmtg_2Gs7UQ5tSs3aVdVVdcwGrBYD7as%2F1PlKQpnjvpVxE-utt_2Gs7WbgEIKf0Rw95lB3eNqqoyx2-clip.m4a',
      layout: 'chatbox',
      paragraphs: [{ start: 0, end: 3, speaker: petrbela }],
      words: DEFAULT_WORDS,
      theme: THEMES[2]!.config,
      title: defaultEpisode.title,
      subtitle: defaultEpisode.subtitle,
      imageUrl: defaultEpisode.image,
      transition: {
        duration: 500,
      },
    },
    {
      kind: 'clip',
      duration: 3,
      mediaUrl:
        'https://storage.googleapis.com/zealous-rooms.appspot.com/recordings%2Fmtg_2Gs7UQ5tSs3aVdVVdcwGrBYD7as%2F1PlKQpnjvpVxE-utt_2Gs7WbgEIKf0Rw95lB3eNqqoyx2-clip.m4a',
      layout: 'block',
      paragraphs: [{ start: 0, end: 3, speaker: gregarious }],
      words: DEFAULT_WORDS,
      theme: THEMES[2]!.config,
      title: defaultEpisode.title,
      subtitle: defaultEpisode.subtitle,
      imageUrl: defaultEpisode.image,
      transition: {
        duration: 250,
      },
    },
    { kind: 'qr', duration: 2 },
  ],
  speakers: [gregarious, petrbela],
  theme: THEMES[2]!.config,
  wordMap: [
    { word: 'NFT', count: 5 },
    { word: 'CPG', count: 4 },
    { word: 'cryptocurrency enthusiasts', count: 4 },
    { word: 'Bitcoin', count: 4 },
    { word: 'Eth', count: 4 },
  ],
}
